
import BaseMixin from '@/views/mixin.vue'
import { mapState, mapGetters } from 'vuex'

import { HttpVsList, HttpCancelVs, HttpActiveVs, HttpInitVs } from '@/service/boss/allot';

import compSearch from './search';
import compDetail from './detail';
import compUpdate from './update';
import compSku from './sku';
import compDelware from './deleteware';
import compnewUpload from '@components/templates/upload';

import { Dropdown, Icon, Button } from 'view-design'


export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        compDetail,
        compUpdate,
        compSku,
        compDelware,
        compnewUpload
    },
    data () {
        return {
            data: [],
            checkedId: [],
        };
    },
    methods: {
        httpList: HttpVsList,
        handleOperates (id, type, row) {
            this.operate = {};
            switch (type) {
                case 'cancel':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('global.common.operatecancel',{defaultValue:'取消操作'}),
                        type,
                    }
                    break;
                case 'delete':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.operate = {
                        title: this.$t('erp.virtualstore.batch_delete_virtual_store', { defaultValue: '批量删除虚拟仓' }),
                        ids: this.checkedId,
                        component: 'compDelware',
                        show: true,
                        width: 500
                    };
                    break;
                case 'active':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('fbb.accountmanage.active_opearte',{defaultValue:'激活操作'}),
                        type,
                    }
                    break;
                case 'sku':
                    this.operate = {
                        id,
                        title: this.$t('erp.virtualstore.copyothersku',{defaultValue:'复制到其他SKU'}),
                        component: 'compSku',
                        show: true,
                        width: 760
                    }; break;
                case 'add':
                    this.$router.push({
                        name: 'vstoreDetail',
                        params: { type: 'add' },
                    });
                    sessionStorage.set('addListformData', '')
                    break;

                case 'query':
                    this.operate = {
                        id,
                        title: this.$t('global.common.query',{defaultValue:'查看'}),
                        component: 'compDetail',
                        show: true,
                        width: 1000,

                    }; break;
                case 'init':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('erp.virtualstore.batchinittalization',{defaultValue:'批量初始化'}),
                        type,
                    }
                    break;

                case 'set':
                    this.$router.push({
                        name: 'vstoreChannel',
                        params: { type: 'set' },
                        query: { id },
                    }); break;
                // 编辑仓库
                case 'edit':
                    this.$router.push({
                        name: 'vstoreEditorWahouse',
                        params: { id },
                    });
                    break;
                // 编辑渠道
                case 'channel':
                    this.$router.push({
                        name: 'vstoreEditorChannel',
                        params: { id },
                    });
                    break;
                // 编辑比例
                case 'allot':
                    this.$router.push({
                        name: 'vstoreEditorAllot',
                        params: { id },
                    });
                    break;
                // 编辑梯级
                case 'ladder':
                    this.$router.push({
                        name: 'vstoreEditorLadder',
                        params: { id },
                    }); break;
                case 'upload':
                    this.operate = {
                        show: true,
                        // title: this.$t('erp.b2c.import_data',{defaultValue:'导入数据'}),
                        title: this.$t('erp.virtualstore.batch_add_warehouse', { defaultValue: '批量新增仓库' }),
                        data: { contextId: global.SYSID },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockVirtualGroup/import/warehouse",
                        name: "excelFile",
                        component: "compnewUpload",
                        warningtitle: this.$t('erp.virtualstore.batch_add_warehouse_tip', { defaultValue: '<div style="text-align:left"><div>1、模板中填写的T级要与虚拟库存分组中T级一致</div><div>2、新增仓库已存在则不处理数据</div></div>'}),
                        showdownload: true,
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/StockVirtualGroup/excel',{},'download')
                        },
                    }
                    break;
                case 'exportQuery':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/StockVirtualGroup/export', { ...this.formData },'download');
                    break;
                case 'exportChannel':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/StockVirtualGroup/exportAccount', { ...this.formData }, 'download');
                    break;
            }
        },
        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'active': request = HttpActiveVs; params = { ids: this.checkedId.join(',') || id }; break;
                case 'cancel': request = HttpCancelVs; params = { ids: this.checkedId.join(',') || id }; break;
                case 'init': request = HttpInitVs; params = { ids: this.checkedId.join(',') || id }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
    },
    computed: {
        // ...mapState('boss',['products']),
        ...mapGetters('diction', ['getNewProductList']),
        columns () {
            return [
                {
                    type: 'selection',
                    width: 60,
                },
                {
                    title: this.$t('global.common.operate',{defaultValue:'操作'}),
                    width: 170,
                    render: (h, { row }) => {
                        const id = row.id, show = row.status !== 'CANCEL';
                        return <div>
                            <Button size='small' type='primary' class='margin-right-5' onClick={this.handleOperates.bind(this, id, 'query')}>{this.$t('global.common.query',{defaultValue:'查看'})}</Button>
                            <Dropdown v-show={show} placement="bottom-start" trigger="click">
                                <Button size='small' type='info'>{this.$t('global.common.operates',{defaultValue:'更多操作'})} &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                                <DropdownMenu slot="list" class="text-left">
                                    <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'query')}>{this.$t('global.common.query',{defaultValue:'查看'})}</DropdownItem>
                                    <DropdownItem v-show={row.status != 'DRAFT'} class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'channel')}>{this.$t('global.common.edit',{defaultValue:'编辑'})}{this.$t('global.common.channel',{defaultValue:'店铺'})}</DropdownItem>

                                    <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'edit')}>{this.$t('global.common.edit',{defaultValue:'编辑'})}{this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'})}</DropdownItem>
                                    <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'allot')}>{this.$t('global.common.edit',{defaultValue:'编辑'})}{this.$t('erp.virtualstore.assignPercent',{defaultValue:'分配比例'})}</DropdownItem>
                                    <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'ladder')}>{this.$t('erp.virtualstore.editladder',{defaultValue:'编辑阶梯'})}</DropdownItem>
                                    <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'sku')}>{this.$t('erp.virtualstore.copyothersku',{defaultValue:'复制到其他SKU'})}</DropdownItem>

                                    <DropdownItem v-show={row.status != 'ACTIVATE'} class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'active')}> {this.$t('erp.channel.active',{defaultValue:'激活'})}</DropdownItem>
                                    <DropdownItem nativeOnClick={this.handleOperates.bind(this, id, 'cancel')}> {this.$t('global.common.operation_cancel',{defaultValue:'取消'})}</DropdownItem>
                                </DropdownMenu>
                            </Dropdown >
                        </div>
                    }
                },
                {
                    title: '#ID',
                    key: 'id',
                    sortable: true,
                    width: 100,
                },
                {
                    title: this.$t('global.common.name',{defaultValue:'名称'}),
                    key: 'name',
                    sortable: true,
                    render: (h, { row }) => {
                        return <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.name}</a>
                    }
                },

                {
                    title: this.$t('global.common.project',{defaultValue:'项目'}),
                    key: 'productLine',
                    sortable: true,
                    render: (h, { row }) => {
                        const id = row.lineId;
                        const product = this.getNewProductList.filter((item) => {
                            return id === item.value
                        })[0] || {};
                        return <span>{product.label}</span>
                    },
                },
                {
                    title: 'ERPSKU',
                    key: 'erpSku',
                    sortable: true,
                    width: 160,
                },
                {
                    title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                    key: 'updatedAt',
                }, {
                    title: this.$t('global.common.status',{defaultValue:'状态'}),
                    key: 'status',
                    sortable: true,
                    // align: 'center',
                    width: 100,
                    render:(h, { row })=>{
                        switch (row.status) {
                            case "ACTIVATE": return <Button class="cursor-default" type='success' size='small'>{this.$t('erp.channel.active',{defaultValue:'激活'})}</Button>; break;
                            case "CANCEL": return <Button class="cursor-default" type='error' size='small'>{this.$t('global.common.operation_cancel',{defaultValue:'取消'})}</Button>; break;
                            case "DRAFT": return <Button class="cursor-default" type='primary' size='small'>{this.$t('fbb.alloment.draft',{defaultValue:'草稿'})}</Button>; break;
                        }
                    }
                }];
        },
    },
};




